<template>
    <div name="hrms-lov-codcomp">
      <div class="lov-box clearfix">
        <template v-for="i in 7">
          <input type="text"  :ref="'lovCodcomp' + i"
                              class="lovCodcomp" maxlength="3"
                              v-model="codcomp[i - 1]"
                              :disabled="disabled" 
                              @focusin="focusCodcomp = i - 1"
                              @keyup="checkNextCodcomp(i, $event.target.value)"
                              @keyup.delete="checkPrevCodcomp(i, $event.target.value)"
                              @keyup.tab="setInputValue()" 
                              @change="setInputValue()" 
                              @keyup.enter="setInputValue()" />
        </template>
        <button v-if="disabled" class="btn-lov-disable" @click.prevent=""><i class="fa fa-search"></i></button>
        <button v-if="!disabled" class="btn-lov" @click.prevent="showModal = true"><i class="fa fa-search color-skin"></i></button>
        <input type="hidden" v-model="inputValue" :name="name" />
        <input type="text" class="form-control detail-lov" :disabled="true" v-show="descDisp" v-model="descInputValue" />
     </div>

      <transition name="modal">
        <div v-if="showModal" class="modal-mask" >
          <div class="modal-wrapper"  >
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header">
                  <i class="fa fa-close close" @click.prevent="closeModal()"></i>
                  <h4 class="modal-title">List of Company</h4>
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  <hrms-table :columns="columns[nowLang].popup"
                          :data="filterData(data)"
                          :indexDisp="false"
                          :isLovTable="true"
                          @setLoadingParentBool="loadingParentBool = arguments[0]"
                          :loadingParentBool="loadingParentBool"
                          :tickEvent="tickEvent" />
                </slot>
              </div>      
            </div>
          </div>
        </div>
      </transition>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as types from 'store/modules/hrmsLovCodcomp/mutation-types'
import labels from 'src/../config/label'
import env from 'src/../env.js'

export default {
  name: 'hrms-lov-codcomp',
  data () {
    return {
      showModal: false,
      codcomp: [ '', '', '', '', '', '', '' ],
      focusCodcomp: 0,
      inputValue: this.value,
      fullInputValue: this.value,
      descInputValue: '',
      currentUser: {},
      flgDelete: false
    }
  },
  watch: {
    value () {
      this.setFocusCodcomp()
      this.setCodcomp(this.value)
      this.inputValue = this.value
      this.fullInputValue = this.value
      this.setInputValue()
    }
  },
  created () {
    this.currentUser = JSON.parse(window.localStorage.getItem(env.site + '_currentUser'))
    this.receivedPopupCodcompColumnsLabels()
    this.receivedPopupCodcomp()
    this.setFocusCodcomp()
    this.setCodcomp(this.value)
  },
  props: {
    value: {
      type: [ String, Number ],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nowLang: {
      type: String,
      default: labels.defaultLang
    },
    name: {
      type: String,
      required: true
    },
    descDisp: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    loadingParentBool () {
      return this.isLoading
    },
    usrCodcomps () {
      return this.currentUser.usrcom
    },
    ...mapGetters({
      data: types.GET_LOV_CODCOMP,
      columns: types.GET_LOV_CODCOMP_COLUMNS,
      labels: types.GET_LOV_CODCOMP_LABELS,
      isLoading: types.GET_LOV_CODCOMP_IS_LOADING
    })
  },
  methods: {
    setFocusCodcomp () {
      if (Math.floor((this.value.length / 3)) > 0) {
        this.focusCodcomp = Math.floor((this.value.length / 3)) - 1
      }
    },
    checkNextCodcomp (index, value) {
      if (value.length === 3 && index < 7) {
        this.$refs['lovCodcomp' + (index + 1)][0].focus()
      }
    },
    checkPrevCodcomp (index, value) {
      this.flgDelete = true
      if (value === '' && index > 1) {
        this.$refs['lovCodcomp' + (index - 1)][0].focus()
      }
    },
    validateCodcomp (dataRow, usrCodcomps, focusCodcomp) {
      let valid = false
      for (var index in usrCodcomps) {
        let usrCodcomp = usrCodcomps[index]
        let strLast = Math.min(usrCodcomp.length, (focusCodcomp + 1) * 3)
        if (dataRow.codcomp.substring(0, strLast) === usrCodcomp.substring(0, strLast)) {
          valid = true
          break
        }
      }
      return valid
    },
    filterData (data) {
      let focusCodcomp = this.focusCodcomp
      let prefixCodcomp = ''
      for (var i = 0; i <= focusCodcomp; i++) {
        prefixCodcomp += this.codcomp[i]
      }
      let prefixCodcompCount = Math.floor(prefixCodcomp.length / 3)
      let suffixCodcomp = ''
      for (var j in this.codcomp) {
        if (j > focusCodcomp) {
          suffixCodcomp += '000'
        }
      }
      let usrCodcomps = this.usrCodcomps
      let validateCodcomp = this.validateCodcomp
      let dataRows = data.rows.filter(function (dataRow) {
        if ((dataRow.codcomp === prefixCodcomp + dataRow.codcomp.substring(prefixCodcompCount * 3, (focusCodcomp + 1) * 3) + suffixCodcomp) && (parseInt(dataRow.comlevel) <= focusCodcomp + 1 && validateCodcomp(dataRow, usrCodcomps, focusCodcomp))) {
          dataRow.v_codcomp = dataRow.codcomp.substring(0, (focusCodcomp + 1) * 3)
          return true
        }
      })
      return {
        total: dataRows.length,
        rows: dataRows
      }
    },
    setInputValue () {
      this.inputValue = ''
      this.fullInputValue = ''
      let focusCodcomp = this.focusCodcomp
      let maxCodcompIndexFound = 0
      for (let i in this.codcomp) {
        if (this.codcomp[i] !== '') {
          maxCodcompIndexFound = i
        }
      }
      for (let i in this.codcomp) {
        this.codcomp[i] = this.codcomp[i].toUpperCase()
        this.inputValue += (this.codcomp[i] !== '') ? this.codcomp[i] : (i < maxCodcompIndexFound) ? '___' : ''
        this.fullInputValue += (this.codcomp[i] !== '') ? this.codcomp[i] : '000'
      }

      if (this.inputValue !== '' && this.data.rows.length > 0) {
        let codcomp = this.fullInputValue
        let usrCodcomps = this.usrCodcomps
        let validateCodcomp = this.validateCodcomp
        let param = this.data.rows.filter(function (dataRow) {
          return dataRow.codcomp === codcomp && validateCodcomp(dataRow, usrCodcomps, focusCodcomp)
        })
        if (param.length > 0) {
          this.descInputValue = param[0].desc_codcomp
        } else {
          this.descInputValue = 'XXXXXXXXXXXXXXXX'
        }
      } else {
        this.descInputValue = ''
      }

      // for manual delete lov
      if (this.flgDelete) {
        this.inputValue = this.inputValue.substring(0, this.focusCodcomp * 3)
        this.flgDelete = false
      }
      this.$emit('input', this.inputValue)
    },
    setCodcomp (codcomp) {
      for (var i in this.codcomp) {
        if (i <= this.focusCodcomp) {
          let substrCodcomp = codcomp.substr((i) * 3, 3)
          this.codcomp[i] = (substrCodcomp !== '___') ? substrCodcomp : ''
        } else {
          this.codcomp[i] = ''
        }
      }
    },
    closeModal () {
      this.showModal = false
      this.$refs['lovCodcomp' + (this.focusCodcomp + 1)][0].focus()
    },
    tickEvent (param) {
      this.inputValue = param.codcomp
      this.descInputValue = param.namcenttha
      this.setCodcomp(param.codcomp)
      this.$emit('input', this.inputValue.substr(0, (this.focusCodcomp + 1) * 3))
      this.$emit('changeLov', this.inputValue)
      this.closeModal()
    },
    ...mapActions({
      receivedPopupCodcompColumnsLabels: types.RECEIVED_LOV_CODCOMP_COLUMNS_LABELS,
      receivedPopupCodcomp: types.RECEIVED_LOV_CODCOMP
    })
  }
}
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow: auto;
  display: block;
}

.modal-wrapper {
  display: block;
}

.modal-container {
  width: 80%;
  max-width: 800px;
  margin: 30px auto;
  padding: 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  overflow-x: auto;
  // font-family: Helvetica, Arial, sans-serif;
  @media (max-width: 480px) {
    margin: 0;
    width: 100%;
  }
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px 0;
  padding: 10px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
  
</style>


// WEBPACK FOOTER //
// component.vue?64166d7d